import request from "../utils/request";

//获取智能体初始化列表
export async function getAgentList(params: any) {
  return request("/api/v1/agent/init", {
    method: "GET",
    params,
  });
}

//AI回答用户问题
export async function getAnswerQuestion(
  params: any,
  onData: (chunk: string) => void
) {
  try {
    const response = request("/api/v1/agent/converse", {
      method: "POST",
      data: params,
      responseType: "stream",
      onDownloadProgress: (progressEvent) => {
        // 处理流式数据
        // 接收数据，去除首尾换行符，解析json数据，获取消息列表
        const chunk = progressEvent.event.currentTarget.response.replace(
          /^\s+|\s+$/g,
          ""
        );
        const lines = chunk.split("\n");
        // 将最后一行数据解析为json数据，获取消息列表
        const json = JSON.parse(lines[lines.length - 1]);
        onData(json);
      },
    });
    return response;
  } catch (error) {
    console.error("请求出错:", error);
    throw error;
  }
}

//切换语言接口
export async function switchLanguages(params: any) {
  return request("/api/v1/agent/change-lang", {
    method: "POST",
    data: params,
  });
}

//关闭会话
export async function closeSession(params: any) {
  return request("/api/v1/agent/close", {
    method: "POST",
    data: params,
  });
}

//打开会话
export async function openSession(params: any) {
  return request("/api/v1/agent/open", {
    method: "POST",
    data: params,
  });
}
